import http from "@/utils/request";

const FluxWmsStockApi = {
  querySkuStock(data) {
    return http.sendRequest({
      METHOD_NAME: "fluxWmsService.queryInventory",
      SECURITY_TYPE: "UserLogin",
      data,
    });
  },
};
export default FluxWmsStockApi;
